import script from "./card-body-social.vue?vue&type=script&setup=true&lang=js"
export * from "./card-body-social.vue?vue&type=script&setup=true&lang=js"

import "./card-body-social.vue?vue&type=style&index=0&id=0eac9ee4&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0eac9ee4"]])

export default __exports__